import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BottomSheet } from "react-spring-bottom-sheet";
import useNavigation from "../../../../hook/useNavigation";
import { tableNumberAuto } from "../../../../store/reducers/order";
import { UFOODX_BASE_URL } from "../../../../utils/constants";
import useToast from '../../../../components/Toast';
import Modal from "../../../../components/Modal";
import { useLocation } from 'react-router-dom';

const InputTableNumber = ({ open, onClose }) => {
    const navigate = useNavigation();
    const { showToast } = useToast();
    const dispatch = useDispatch();

    const { details: outlet } = useSelector((store) => store?.outlet);
    const company = useSelector((store) => store?.company);
    const user = useSelector((store) => store?.user);
    const [tableNumber, setTableNumber] = useState("");
    const { pathname } = useLocation();
	const parentRoute = pathname.substring(0, pathname.lastIndexOf('/')) || '/';
    const location = useLocation();
    const isUfoodX = location.pathname.includes('ufood-x');

    const handleContinue = async () => {
        if (!tableNumber) return;

        try {
            await dispatch(
                tableNumberAuto({
                    companyId: Number(company?.companyID || user?.companyID),
                    outletId: Number(outlet?.storeID),
                    brandId: Number(outlet?.brand_id),
                    tableNumber: Number(tableNumber),
                })
            ).unwrap();

            onClose();
            if (isUfoodX) {
                navigate.push(`${UFOODX_BASE_URL}/${outlet?.storeSlug}/dinein`);
            }
            navigate.push(`${parentRoute}/dinein`);
        } catch (err) {
            showToast("error", err?.message, 2000);
        }
    };

    return (
        <Modal isOpen={open} onClose={onClose}>
            <div className="p-4 pb-6">
                <div className="text-sm font-semibold text-gray-800 mb-2">
                    Table/Queue Number <span className="text-red-500">*</span>
                </div>
                <div className="text-xs text-gray-500 mb-2">
                    Pastikan nomor meja sesuai dengan yang Anda gunakan.
                </div>

                <input
                    type="number"
                    inputMode="numeric"
                    min={1}
                    autoFocus
                    placeholder="Type here"
                    value={tableNumber}
                    onChange={(e) => setTableNumber(e.target.value)}
                    className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2"
                />

                <button
                    onClick={handleContinue}
                    disabled={!tableNumber}
                    className="mt-4 w-full bg-[var(--rose-violet)] text-white text-sm font-semibold py-2 rounded-lg disabled:opacity-40"
                >
                    Continue
                </button>
            </div>
        </Modal>
    );
};

export default InputTableNumber;